import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "is-logged-in": () => import("/app/middleware/isLoggedIn.js"),
  "is-logged-out": () => import("/app/middleware/isLoggedOut.js")
}